import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import DistributorOrdersDetailsTable from "../../components/orderTables/distributorOrderDetailsTable";
import "./distributor.css";
import {
  distributorDetail,
  enableDisableDistributor,
} from "../../redux/actions/distributorActions";
import "../customers/customers.css";
import DistrictEditModal from "../../components/modals/Distributor/DistrictEditModal";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const DistributorDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [distributorDetailData, setDistributorDetailData] = useState(null);
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [ondistrictEditShow, setOnDistrictEditShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Distributor" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (id) => {
    console.log(id);
    dispatch(
      enableDisableDistributor(id, onEnableDisableSuccess, onEnableDisableError)
    );
  };

  const onEnableDisableSuccess = (data) => {
    console.log(data);
    setOnEnableShow(false);
    fetchDistributerDetail();
  };

  const onEnableDisableError = (err) => {
    console.log(err);
  };

  const fetchDistributerDetail = () => {
    dispatch(distributorDetail(params?.id, onSuccess, onError));
  };

  useEffect(() => {
    setLoading(true);
    fetchDistributerDetail();
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setDistributorDetailData(data?.data?.data);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const contactDetails = [
    {
      heading: "Mobile Number",
      title: distributorDetailData?.mobile
        ? distributorDetailData?.mobile
        : "--",
    },
    {
      heading: "Alternate Mobile Number",
      title: distributorDetailData?.alternate_mobile
        ? distributorDetailData?.alternate_mobile
        : "--",
    },
    {
      heading: "Email Address",
      title: distributorDetailData?.email ? distributorDetailData?.email : "--",
    },
    {
      heading: "Alternate Email Address",
      title: distributorDetailData?.alternate_email
        ? distributorDetailData?.alternate_email
        : "--",
    },
    {
      heading: "State",
      title: distributorDetailData?.state?.name
        ? distributorDetailData?.state?.name
        : "--",
    },
    {
      heading: "City",
      title: distributorDetailData?.city?.name
        ? distributorDetailData?.city?.name
        : "--",
    },
    {
      heading: "District Covered",
      title:
        distributorDetailData?.distributorDistrictCoveredByDistributors != [] &&
        distributorDetailData?.distributorDistrictCoveredByDistributors?.map(
          (ele, index) => {
            return (
              <span key={index}>
                {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
                {ele?.district?.name ? ele?.district?.name : "--"}
              </span>
            );
          }
        ),
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/distributors/onboarded",
      breadcrumb: " / distributors / onboarded distributors",
    },
    {
      path: "/distributors/onboarded/view/:id",
      breadcrumb: distributorDetailData?.distributor_id
        ? ` / ${distributorDetailData?.distributor_id} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      <div className="products-page text-nowrap">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              {(user_type == "super_user" && userData?.write) ||
              user_type == "vendor" ? (
                <div className=" d-flex justify-content-between m-1 mb-2 ">
                  <AdminButton
                    background="#7065e4"
                    color="white"
                    width="130px"
                    onClick={() => setOnDistrictEditShow(true)}
                  >
                    <span className="m-2">EDIT DISTRICT</span>
                  </AdminButton>
                  <AdminButton
                    color={
                      distributorDetailData?.status ? "#FF6F5B" : "#24D626"
                    }
                    border={
                      distributorDetailData?.status
                        ? "1px solid #FF6F5B"
                        : "1px solid #24D626"
                    }
                    width="110px"
                    onClick={() => setOnEnableShow(true)}
                  >
                    <span className="m-2">
                      {distributorDetailData?.status ? "DISABLE" : "ENABLE"}
                    </span>
                  </AdminButton>
                </div>
              ) : (
                " "
              )}
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="main-view-page scrolling">
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Basic Details
                    </div>
                    <div className="product-details-container ms-3">
                      <div className="pt-3 row row-cols-5">
                        <div className="mb-2 col-10 col-md-5  col-xxl me-4">
                          <h5 className="color_747f9e fs_14 fw_500 m-0">
                            Distributor ID
                          </h5>
                          <p className={`fs_15 fn_Nunito fw_500 `}>
                            {distributorDetailData?.distributor_id
                              ? distributorDetailData?.distributor_id
                              : "--"}
                          </p>
                        </div>
                        <div className="mb-2 col-10 col-md-5  col-xxl me-4">
                          <h5 className="color_747f9e fs_14 fw_500 m-0">
                            Firm Name
                          </h5>
                          <p className={`fs_15 fn_Nunito fw_500 `}>
                            {distributorDetailData?.firm_name
                              ? distributorDetailData?.firm_name
                                  .charAt(0)
                                  .toUpperCase() +
                                distributorDetailData?.firm_name.slice(1)
                              : "--"}
                          </p>
                        </div>
                        <div className="mb-2 col-10 col-md-5  col-xxl me-4">
                          <h5 className="color_747f9e fs_14 fw_500 m-0">
                            Drug License Number - 20A
                          </h5>
                          <p className={`fs_15 fn_Nunito fw_500 `}>
                            {distributorDetailData?.drug_licence_number_20_a
                              ? distributorDetailData?.drug_licence_number_20_a
                              : "--"}
                          </p>
                        </div>
                        <div className="mb-2 col-10 col-md-5  col-xxl me-4">
                          <h5 className="color_747f9e fs_14 fw_500 m-0">
                            Drug License Number - 20B
                          </h5>
                          <p className={`fs_15 fn_Nunito fw_500 `}>
                            {distributorDetailData?.drug_licence_number_20_b
                              ? distributorDetailData?.drug_licence_number_20_b
                              : "--"}
                          </p>
                        </div>
                        <div className="mb-2 col-10 col-md-5  col-xxl me-4">
                          <h5 className="color_747f9e fs_14 fw_500 m-0">
                            FSSAI Number
                          </h5>
                          <p className={`fs_15 fn_Nunito fw_500 `}>
                            {distributorDetailData?.fssai_number
                              ? distributorDetailData?.fssai_number
                              : "--"}
                          </p>
                        </div>
                        <div className="mb-2 col-10 col-md-5  col-xxl me-4">
                          <h5 className="color_747f9e fs_14 fw_500 m-0">
                            GST Number
                          </h5>
                          <p className={`fs_15 fn_Nunito fw_500 `}>
                            {distributorDetailData?.gst_number
                              ? distributorDetailData?.gst_number
                              : "--"}
                          </p>
                        </div>
                       
                      </div>
                    </div>
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Contact Details
                    </div>
                    <div className="product-details-container">
                      <div className="pt-3 row row-cols-5 ms-1">
                        {contactDetails.map((item, index) => (
                          <div className="mb-2 col-10 col-sm-6 col-lg-4 col-xxl-2 mx-0 px-3 me-lg-5">
                            <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                              {item.heading}
                            </h5>
                            {item.heading === "Email Address" ? (
                              <p
                                className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice`}
                                title={item.title}
                              >
                                {item.title}
                              </p>
                            ) : item.heading ? (
                              <p className="fs_15 fn_Nunito fw_500 color_262c3d">
                                {item.title}
                              </p>
                            ) : (
                              <p
                                className={`fs_15 fn_Nunito fw_500 color_262c3d  text-nowrap`}
                              >
                                {item.title}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                    Order Details
                  </div>
                  <div className="my-4">
                    <DistributorOrdersDetailsTable
                      orders={distributorDetailData?.orders}
                    />
                  </div>
                 
                </div>
              )}
            </div>
          </div>
        </div>
        <EnableDisableModal
          show={onEnableShow}
          handleClose={() => setOnEnableShow(false)}
          status={distributorDetailData?.status}
          id={params?.id}
          enableDisableFunc={enableDisableFunc}
          title={`distributor - ${distributorDetailData?.distributor_id}?`}
        />

        <DistrictEditModal
          show={ondistrictEditShow}
          servingDistricts={distributorDetailData?.distributorDistrictCoveredByVendors?.map(
            (ele) => ele?.district?.id
          )}
          distributorID={distributorDetailData?.id}
          fetchDistributerDetail={fetchDistributerDetail}
          handleClose={() => setOnDistrictEditShow(false)}
        />
      </div>
    </>
  );
};

export default DistributorDetail;
